import { useInvalidateMyDesigns } from '@/entities/my-design';
import { trpc } from '@/shared/api';

/** 내 디자인 복제(designs.duplicate) — 사본은 최근 수정순 맨 앞에 오므로 목록을 다시 읽으면 바로 보인다. */
export const useDuplicateMyDesign = () => {
  const invalidate = useInvalidateMyDesigns();
  const mutation = trpc.designs.duplicate.useMutation();
  return {
    duplicate: async (designId: string): Promise<void> => {
      await mutation.mutateAsync({ id: designId });
      await invalidate();
    },
    isPending: mutation.isPending,
  };
};
